import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Nav, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTachometerAlt, faCubes, faComments, 
  faSignOutAlt, faServer, faRobot, faUser
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';

function AdminLayout() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getTitle = () => {
    const path = location.pathname;
    if (path === '/admin') return 'Admin Dashboard';
    if (path === '/admin/frameworks') return 'Frameworks';
    if (path === '/admin/channels') return 'Channels';
    if (path === '/admin/mcp') return 'MCP Configuration';
    if (path === '/admin/openai') return 'OpenAI Settings';
    if (path === '/admin/plans') return 'Plans';
    if (path === '/admin/users') return 'Users';
    if (path === '/admin/earnings') return 'Earnings';
    return 'Admin Panel';
  };
  
  return (
    <Container fluid>
      <Row>
        {/* Admin Sidebar - Updated with professional colors */}
        <Col md={3} lg={2} className="p-0 admin-sidebar min-vh-100">
          <div className="d-flex align-items-center justify-content-center p-3 admin-header">
            <h4 className="text-white m-0 fw-bold">Admin Panel</h4>
          </div>
          <hr className="mt-0 mb-3 admin-divider" />
          
          <Nav className="flex-column admin-nav">
            <Link to="/admin" className={`nav-link admin-nav-link ${location.pathname === '/admin' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faTachometerAlt} className="me-2" /> Dashboard
            </Link>
            <Link to="/admin/frameworks" className={`nav-link admin-nav-link ${location.pathname === '/admin/frameworks' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faCubes} className="me-2" /> Frameworks
            </Link>
            <Link to="/admin/channels" className={`nav-link admin-nav-link ${location.pathname === '/admin/channels' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faComments} className="me-2" /> Channels
            </Link>
            <Link to="/admin/mcp" className={`nav-link admin-nav-link ${location.pathname === '/admin/mcp' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faServer} className="me-2" /> MCP Configuration
            </Link>
            <Link to="/admin/openai" className={`nav-link admin-nav-link ${location.pathname === '/admin/openai' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faRobot} className="me-2" /> OpenAI Settings
            </Link>
            <Link to="/admin/plans" className={`nav-link admin-nav-link ${location.pathname === '/admin/plans' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faCubes} className="me-2" /> Plans
            </Link>
            <Link to="/admin/users" className={`nav-link admin-nav-link ${location.pathname === '/admin/users' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faUser} className="me-2" /> Users
            </Link>
            <Link to="/admin/earnings" className={`nav-link admin-nav-link ${location.pathname === '/admin/earnings' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faTachometerAlt} className="me-2" /> Earnings
            </Link>
            
            <hr className="my-2 admin-divider" />
            
            <Nav.Link onClick={handleLogout} className="nav-link admin-nav-link">
              <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
            </Nav.Link>
          </Nav>
        </Col>
        
        {/* Main Content */}
        <Col md={9} lg={10} className="p-4 admin-content">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="admin-title">{getTitle()}</h2>
            <div className="user-info">
              <span className="me-2 admin-user-name">{currentUser?.name}</span>
              <Badge bg="info" className="admin-badge">
                <FontAwesomeIcon icon={faUser} className="me-1" /> Super Admin
              </Badge>
            </div>
          </div>
          
          {/* Admin page content */}
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export default AdminLayout;
